import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';

const URLS = {
  SUBSCRIBE: '/org/%s/projects/%s/subscribe/',
  BALANCE: '/org/%s/payments/token-event/?ordering=-created_at',
  DONATE: '/org/%s/payments/token-event/donate/',
};

export default {
  subscribe: ({ projectId, orgName }: { projectId: number; orgName: string }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.SUBSCRIBE, orgName, projectId),
    }),
  getOrganizationBalanceHistory: ({ orgName }: { orgName: string }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.BALANCE, orgName),
    }),
  donateOrgToken: ({ orgName, tokens }: { orgName: string; tokens: number }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.DONATE, orgName),
      data: {
        quantity: tokens,
      },
    }),
};
